<div
  class="container"
  [class.horizontal]="direction === 'left' || direction === 'right'">
  @if (direction === 'down' || direction === 'right') {
    <div [attr.class]="direction === 'down' ? 'content-vertical-space' : 'content-horizonal-space'"></div>
  }

  <div
    class="content"
    [class.warning]="type === 'warning'"
    [class.error]="type === 'error'"
    [style.border-color]="backgroundColor">
    @if (connectToElement || hostElement) {
      <svg
        [attr.class]="'connector direction-' + direction"
        [ngStyle]="connectorStyle">
        @if (direction === 'up') {
          <path
            d="M0,0 l10,0 l-5,5 Z"
            [style.fill]="backgroundColor"></path>
        }
        @if (direction === 'down') {
          <path
            d="M5,0 l5,5 l-10,0 Z"
            [style.fill]="backgroundColor"></path>
        }
        @if (direction === 'left') {
          <path
            d="m5,5 -5,5 V 0.5 Z"
            [style.fill]="backgroundColor"></path>
        }
        @if (direction === 'right') {
          <path
            d="m0,5 5,-5 V 10 Z"
            [style.fill]="backgroundColor"></path>
        }
      </svg>
    }
    <div
      class="text-holder"
      [class.preserve-whitespace]="preserveWhitespace"
      [class.no-padding]="noPadding"
      [style.background-color]="backgroundColor"
      [style.color]="fontColor">
      @if (isTextString()) {
        <div>{{ text }}</div>
      } @else {
        @if (text) {
          <ng-container *ngTemplateOutlet="text"></ng-container>
        } @else {
          <ng-content></ng-content>
        }
      }
    </div>
  </div>

  @if (direction === 'up' || direction === 'left') {
    <div [attr.class]="direction === 'up' ? 'content-vertical-space' : 'content-horizonal-space'"></div>
  }
</div>
